var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 21 17",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M18.0273 2.12695H10.0273L8.02734 0.126953H2.02734C0.927344 0.126953 0.0373437 1.02695 0.0373437 2.12695L0.0273438 14.127C0.0273438 15.227 0.927344 16.127 2.02734 16.127H18.0273C19.1273 16.127 20.0273 15.227 20.0273 14.127V4.12695C20.0273 3.02695 19.1273 2.12695 18.0273 2.12695ZM12.0273 12.127H4.02734V10.127H12.0273V12.127ZM16.0273 8.12695H4.02734V6.12695H16.0273V8.12695Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }